import { validateGenptScheduleSlotRequest } from '../../../../hooks/siembagpt';
import { buildGenptScheduleTimeConflictKey } from './mapGenptScheduleToEditPrefill';

/**
 * True when another active schedule on the asset conflicts with this slot (POST `/genpt/schedules/validate`).
 * Skips the request when the wizard cannot build a valid conflict key (invalid date/time).
 */
export async function hasGenptScheduleSlotConflict({
  assetId,
  scheduleUi,
  excludeScheduleId,
  signal,
}) {
  const aid =
    assetId != null && String(assetId).trim() !== '' ? String(assetId).trim() : null;
  if (!aid || !scheduleUi || typeof scheduleUi !== 'object') return false;
  const anchorYmd =
    scheduleUi.startDate != null && String(scheduleUi.startDate).trim() !== ''
      ? String(scheduleUi.startDate).trim()
      : null;
  if (!anchorYmd) return false;
  const draftKey = buildGenptScheduleTimeConflictKey(scheduleUi, anchorYmd);
  if (!draftKey) return false;
  try {
    const data = await validateGenptScheduleSlotRequest({
      assetId: aid,
      schedule: scheduleUi,
      excludeScheduleId,
      signal,
    });
    if (data?.success === false) return false;
    return data?.available === false;
  } catch {
    return false;
  }
}
